import { render, staticRenderFns } from "./GroupSwitch.vue?vue&type=template&id=130a273e"
import script from "./GroupSwitch.vue?vue&type=script&lang=js"
export * from "./GroupSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports